import { SafeHtml } from "@angular/platform-browser";
import { StihlFileDTO } from "./stihl-file-dto";

export class StihlPollDTO {
  IdPoll: string | null;
  IdPollType: number;
  Status: boolean;
  Title: string;
  Description: string;
  File: StihlFileDTO | null;
}

export class StihlPollPostDTO {
  IdPollType: number;
  Status: boolean;
  Title: string;
  Content: string | null;
  FormFile: File | null;
}

export class StihlPollUserDTO {
  IdPollUser: number;
  IdUser: string;
  IdPoll: number;
  IdData: string;
  Data: string;
}